import { memo, useMemo } from 'react'
import { Table, Space, Popconfirm } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { LeagueDivision } from 'types/league-divisions'
import { modalTitle as formatModalTitle } from 'utils/modal-title'

type Props = {
    data: LeagueDivision[]
    onEdit: (id: number) => void
    onDelete: (id: number) => void
    loading: boolean
}

export const LeagueDivisionsTable = memo((props: Props) => {
    const { data, onEdit, onDelete, loading } = props

    const columns: ColumnsType<LeagueDivision> = useMemo(
        () => [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Action',
                key: 'action',
                render: (_, record) => (
                    <Space size='middle'>
                        <a onClick={() => onEdit(record.id)}>Edit</a>
                        <Popconfirm
                            title={formatModalTitle('Delete league division', record.name)}
                            description={'Are you sure to delete this league division?'}
                            onConfirm={() => onDelete(record.id)}
                            okText={'Yes'}
                            cancelText={'No'}
                        >
                            <a href='#'>Delete</a>
                        </Popconfirm>
                    </Space>
                ),
            },
        ],
        [onDelete, onEdit]
    )

    return <Table loading={loading} columns={columns} dataSource={data} rowKey='id' pagination={false} />
})
